import { Components } from '../../../../component-classes';
import { ActionRuleParams } from '../../types';
import { syncAccessorySkuCount } from '../../helpers';

import type { Island } from '../../../islands/island.class';
import type { Panel } from '../../../panels/panel.class';
import type { PanelItemGroup } from '../../../panel-item-groups/panel-item-group.class';
import type { PanelItem } from '../../../panel-items/panel-item.class';

const SKU = 'CUSTOM_OPENINGINCOUNTER_';

const isCountertopCutout = (panelItem: PanelItem): boolean => {
	const { item } = panelItem;
	const { category, placement } = item;

	// Must be cutout category
	if (category?.key !== 'cutout') return false;

	// Must be top only placement (countertop cutout)
	if (placement !== Components.PLACEMENT_TOP_ONLY) return false;

	return true;
};

export const openingInCounter = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { kitchen } = refMap;
	if (!kitchen) return;

	const islands = refMap.islands ?? kitchen.design?.islands ?? null;
	if (!islands) return;

	let qualifyingCount = 0;

	for (const child of islands.children) {
		const island = child as Island;

		for (const panel of island.panels.children) {
			const typedPanel = panel as Panel;

			for (const group of typedPanel.panelItemGroups.children) {
				const typedGroup = group as PanelItemGroup;

				for (const panelItem of typedGroup.items.children) {
					if (isCountertopCutout(panelItem as PanelItem)) {
						qualifyingCount++;
					}
				}
			}
		}
	}

	syncAccessorySkuCount({ kitchen, sku: SKU, qualifyingCount });
};
